module.exports = __webpack_public_path__ + "static/media/mountadex-landing-tablet.88e6aa22.jpg";